var map = {
	"./ion-accordion_2.entry.js": [
		5633,
		5633
	],
	"./ion-action-sheet.entry.js": [
		7388,
		7388
	],
	"./ion-alert.entry.js": [
		2381,
		2381
	],
	"./ion-app_8.entry.js": [
		2529,
		2529
	],
	"./ion-avatar_3.entry.js": [
		1098,
		9697
	],
	"./ion-back-button.entry.js": [
		5454,
		5454
	],
	"./ion-backdrop.entry.js": [
		5548,
		5548
	],
	"./ion-breadcrumb_2.entry.js": [
		8407,
		8407
	],
	"./ion-button_2.entry.js": [
		1875,
		1875
	],
	"./ion-card_5.entry.js": [
		5132,
		5132
	],
	"./ion-checkbox.entry.js": [
		4628,
		4628
	],
	"./ion-chip.entry.js": [
		6599,
		6599
	],
	"./ion-col_3.entry.js": [
		2011,
		2011
	],
	"./ion-datetime-button.entry.js": [
		7456,
		2112,
		7456
	],
	"./ion-datetime_3.entry.js": [
		5554,
		2112,
		5554
	],
	"./ion-fab_3.entry.js": [
		6965,
		6965
	],
	"./ion-img.entry.js": [
		8943,
		8943
	],
	"./ion-infinite-scroll_2.entry.js": [
		8600,
		8600
	],
	"./ion-input-otp.entry.js": [
		133,
		133
	],
	"./ion-input-password-toggle.entry.js": [
		5274,
		1041
	],
	"./ion-input.entry.js": [
		395,
		395
	],
	"./ion-item-option_3.entry.js": [
		1246,
		1246
	],
	"./ion-item_8.entry.js": [
		7431,
		7431
	],
	"./ion-loading.entry.js": [
		1736,
		1736
	],
	"./ion-menu_3.entry.js": [
		5661,
		5661
	],
	"./ion-modal.entry.js": [
		1564,
		1564
	],
	"./ion-nav_2.entry.js": [
		9545,
		9545
	],
	"./ion-picker-column-option.entry.js": [
		3825,
		3825
	],
	"./ion-picker-column.entry.js": [
		3286,
		3286
	],
	"./ion-picker.entry.js": [
		3651,
		3651
	],
	"./ion-popover.entry.js": [
		1141,
		1141
	],
	"./ion-progress-bar.entry.js": [
		9020,
		9020
	],
	"./ion-radio_2.entry.js": [
		5985,
		5985
	],
	"./ion-range.entry.js": [
		5264,
		5264
	],
	"./ion-refresher_2.entry.js": [
		9892,
		9892
	],
	"./ion-reorder_2.entry.js": [
		4748,
		4748
	],
	"./ion-ripple-effect.entry.js": [
		9150,
		9150
	],
	"./ion-route_4.entry.js": [
		2379,
		2379
	],
	"./ion-searchbar.entry.js": [
		8418,
		8418
	],
	"./ion-segment-content.entry.js": [
		345,
		345
	],
	"./ion-segment-view.entry.js": [
		8027,
		8027
	],
	"./ion-segment_2.entry.js": [
		6788,
		6788
	],
	"./ion-select-modal.entry.js": [
		363,
		363
	],
	"./ion-select_3.entry.js": [
		5787,
		5787
	],
	"./ion-spinner.entry.js": [
		566,
		566
	],
	"./ion-split-pane.entry.js": [
		1581,
		1581
	],
	"./ion-tab-bar_2.entry.js": [
		8674,
		8674
	],
	"./ion-tab_2.entry.js": [
		4474,
		4474
	],
	"./ion-text.entry.js": [
		9382,
		9382
	],
	"./ion-textarea.entry.js": [
		8948,
		8948
	],
	"./ion-toast.entry.js": [
		1099,
		1099
	],
	"./ion-toggle.entry.js": [
		8438,
		8438
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 863;
module.exports = webpackAsyncContext;